import { defineMessages } from 'react-intl';

export default defineMessages({
  customAmountMissing: {
    id: 'gift.customAmountField.missing',
    defaultMessage: 'Please enter a valid custom amount',
    description: 'Error message displayed when the custom amount is missing',
  },
  customAmountError: {
    id: 'gift.customAmountField.error',
    defaultMessage:
      'Please enter a whole amount between {minAmount} and {maxAmount}',
    description:
      'Error message displayed the custom amount entered is out of bounds',
  },
});
